if (!customElements.get('m-quickchat-ai')) {
  class mQuickchatAI extends HTMLElement {
    constructor() {
      super();
      this.onInputChange = this.onInputChange.bind(this);
      this.onFormSubmit = this.onFormSubmit.bind(this);
      this.onPromptClick = this.onPromptClick.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('[data-chatai-form]');
      this.input = this.querySelector('[data-chatai-input]');
      this.submit = this.querySelector('[data-chatai-submit]');
      this.promptButtons = Array.from(this.querySelectorAll('[data-chatai-prompt]'));

      if (!this.form || !this.input || !this.submit) return;

      this.updateSubmitState();
      this.input.addEventListener('input', this.onInputChange);
      this.form.addEventListener('submit', this.onFormSubmit);
      this.promptButtons.forEach((button) => button.addEventListener('click', this.onPromptClick));
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInputChange);
      this.form?.removeEventListener('submit', this.onFormSubmit);
      this.promptButtons?.forEach((button) => button.removeEventListener('click', this.onPromptClick));
    }

    onInputChange() {
      this.updateSubmitState();
    }

    onPromptClick(event) {
      const message = event.currentTarget.dataset.chataiPrompt?.trim();

      if (!message) return;

      this.sendToQuickchat(message);
    }

    onFormSubmit(event) {
      event.preventDefault();

      const message = this.input.value.trim();

      if (!message) return;

      this.input.value = '';
      this.updateSubmitState();
      this.sendToQuickchat(message);
    }

    updateSubmitState() {
      const hasValue = this.input.value.trim().length > 0;

      this.submit.classList.toggle('is-active', hasValue);
      this.submit.disabled = !hasValue;
    }

    sendToQuickchat(message) {
      if (!message || typeof window._quickchat !== 'function') return;

      window._quickchat('message', message);
    }
  }

  customElements.define('m-quickchat-ai', mQuickchatAI);
}
